import { doGraphqlRequest } from 'ducks/requests'
import { SETTINGS_INTEGRATIONS_PROVIDER_PAGE } from 'subapps/settings/types'
import * as types from '../types'
import splitAuthValues from '../utils/splitAuthValues'
import { selectIsFullyLoaded } from '../selectors/base'
import { doUpsertJiraServerCredentials } from './doUpsertJiraServerCredentials'

export {
  default as doFetchExternalResourcesForNewActions,
} from './doFetchExternalResourcesForNewActions'

const removeIntegrationsByProviderMutation = `
  mutation IntegrationDeleteByProvider(
    $provider: IntegrationProvider!,
  ) {
    integrationDeleteByProvider(input: {
      provider: $provider
    }) {
      deletedIntegrationIds
    }
  }
`
export const doRemoveIntegrationsByProvider = provider => dispatch => {
  const variables = { provider }
  dispatch(
    doGraphqlRequest(
      types.REMOVE_INTEGRATION_BY_PROVIDER,
      removeIntegrationsByProviderMutation,
      variables,
      {
        app: true,
        meta: { provider },
        transformResponse: data =>
          data.integrationDeleteByProvider.deletedIntegrationIds,
      }
    )
  )
}
const removeIntegrationMutation = `
  mutation IntegrationDelete(
    $integrationId: ID!,
  ){
    integrationDelete(input: {
      integrationId: $integrationId
    }) {
      deletedIntegrationId
    }
  }
`

export const doRemoveIntegration = id => dispatch => {
  const variables = { integrationId: id }
  dispatch(
    doGraphqlRequest(
      types.REMOVE_INTEGRATION,
      removeIntegrationMutation,
      variables,
      {
        app: true,
        meta: { integrationId: id },
        transformResponse: data => data.deleteIntegration,
      }
    )
  )
}

const addShopifyMutation = `
  mutation AddShopifyStore(
    $apiKey: String!,
    $apiPassword: String!,
    $storeName: String!,
    $storeDomain: String!,
  ){
    addShopifyStore(
      apiKey: $apiKey,
      apiPassword: $apiPassword,
      storeName: $storeName,
      storeDomain: $storeDomain,
    ) {
      id
    }
  }
`

export const doAddShopifyStore = params => dispatch =>
  dispatch(
    doGraphqlRequest(types.ADD_SHOPIFY_STORE, addShopifyMutation, params)
  )

const updateShopifyMutation = `
  mutation UpdateShopifyStore(
    $id: ID!,
    $apiKey: String,
    $apiPassword: String,
    $storeName: String!,
    $storeDomain: String!,
  ){
    updateShopifyStore(
      id: $id,
      apiKey: $apiKey,
      apiPassword: $apiPassword,
      storeName: $storeName,
      storeDomain: $storeDomain,
    ) {
      id
    }
  }
`
export const doUpdateShopifyStore = params => dispatch =>
  dispatch(
    doGraphqlRequest(types.EDIT_SHOPIFY_STORE, updateShopifyMutation, params)
  )

const fetchIntegrationsMutation = `
  query IntegrationsQuery {
    integrations {
      nodes {
        __typename
        ... on Integration {
          id
          legacyId
          provider
          settings {
            settings
          }
        }

        ... on UserIntegration {
          agent {
            id
          }
        }

        ... on ChannelIntegration {
          channel {
            id
          }
        }

        ... on ShopifyV2Integration {
          storeName
          storeDomain
        }

        ... on ShopifyIntegration {
          storeName
          storeDomain
        }

        ... on JiraServerIntegration {
          username
          url
        }
      }
    }
  }
`

export const doFetchIntegrations = () => (dispatch, getState) => {
  const state = getState()
  if (selectIsFullyLoaded(state)) return
  // eslint-disable-next-line consistent-return
  return dispatch(
    doGraphqlRequest(
      types.FETCH_INTEGRATIONS,
      fetchIntegrationsMutation,
      {},
      { app: true }
    )
  )
}

export const doOpenProviderPage = provider => () => dispatch => {
  dispatch({ type: SETTINGS_INTEGRATIONS_PROVIDER_PAGE, payload: { provider } })
}

const updateIntegrationProviderSettingsMutation = `
  mutation IntegrationProviderSettingsUpdate(
    $provider: IntegrationProvider!,
    $settings: JSON!
  ) {
    integrationProviderSettingsUpdate(input: {
      provider: $provider,
      settings: $settings
    }) {
      integrations {
        nodes {
          id
          settings {
            settings
          }
        }
      }
    }
  }
`

export const doUpdateIntegrationProviderSettings = (
  provider,
  values
) => dispatch => {
  const [settingValues, authValues] = splitAuthValues(values)
  const variables = {
    provider: provider.toUpperCase(),
    settings: settingValues,
  }

  if (provider === 'jira_server')
    dispatch(doUpsertJiraServerCredentials(authValues))
  dispatch(
    doGraphqlRequest(
      types.UPDATE_INTEGRATION_SETTINGS,
      updateIntegrationProviderSettingsMutation,
      variables,
      { app: true }
    )
  )
}

const updateIntegrationSettingsMutation = `
  mutation IntegrationSettingsUpdate(
    $integrationId: ID!,
    $settings: JSON!
  ) {
    integrationSettingsUpdate(input: {
      integrationId: $integrationId,
      settings: $settings
    }) {
      integration {
        __typename
        ... on Integration {
          id
          provider
          settings {
            settings
          }
        }

        ... on UserIntegration {
          agent {
            id
          }
        }

        ... on ChannelIntegration {
          channel {
            id
          }
        }

        ... on ShopifyV2Integration {
          storeName
          storeDomain
        }

        ... on ShopifyIntegration {
          storeName
          storeDomain
        }

        ... on JiraServerIntegration {
          username
          url
          agent {
            id
          }
        }
      }
    }
  }
`

export const doUpdateIntegrationSettings = (
  integrationId,
  values
) => dispatch => {
  const variables = {
    integrationId,
    settings: values,
  }

  dispatch(
    doGraphqlRequest(
      types.UPDATE_INTEGRATION_SETTINGS,
      updateIntegrationSettingsMutation,
      variables,
      { app: true }
    )
  )
}
